import React, { useState, useEffect } from "react";
import { Formik, Form, Field } from "formik";
import Modal from "../../../../../constants/Modal";
import ExercisesTrainingService from "../../../../../services/exercises/training/ExercisesTrainingService";
import DictUnitsService from "../../../../../services/dict/DictUnitsService";
import DictQuantityTypeService from "../../../../../services/dict/DictQuantityTypeService";
import { Exercise, DictQuantityType, DictUnits } from "../../../../../types/types";
import { withTranslation } from "react-i18next";

type Props = {
  exerciseId: string;
  trainingId: number;
  onExerciseUpdate: () => void;
  t: any;
};

const OptionsCopyAndEdit: React.FC<Props> = ({ exerciseId, trainingId, onExerciseUpdate, t }) => {
  const [showModal, setShowModal] = useState(false);
  const [exerciseData, setExerciseData] = useState<Exercise | null>(null);
  const [dictUnits, setDictUnits] = useState<DictUnits[]>([]);
  const [dictQuantityTypes, setDictQuantityTypes] = useState<DictQuantityType[]>([]);

  const handleCopyAndEdit = async () => {
    try {
      // 1. Wczytaj słowniki
      const [units, quantityTypes, exerciseResponse] = await Promise.all([
        DictUnitsService.getDictUnits(),
        DictQuantityTypeService.getDictQuantityTypes(),
        ExercisesTrainingService.getExerciseById(exerciseId),
      ]);
      setDictUnits(units.data);
      setDictQuantityTypes(quantityTypes.data);
      setExerciseData(exerciseResponse.data);
      setShowModal(true);
    } catch (error) {
      console.error("Error loading exercise data:", error);
    }
  };

  const handleSubmit = async (values: Exercise) => {
    try {
      // 2. Najpierw kopiuj ćwiczenie
      const response = await ExercisesTrainingService.copyExercise(trainingId, exerciseId);
      const newExerciseId = response.data;

      // 3. Potem aktualizuj nową kopię
      await ExercisesTrainingService.updateExercise(newExerciseId, trainingId, values);

      onExerciseUpdate();
      setShowModal(false);
    } catch (error) {
      console.error("Error updating copied exercise:", error);
    }
  };

  return (
    <>
      <div className="center">
        <button onClick={handleCopyAndEdit}>
          {t("buttons.copy_and_edit")}
        </button>
        {/* <p>{t("buttons.copy_and_edit_description")}<br /><br /></p> */}
        <br /><br />
      </div>

      <Modal show={showModal} onClose={() => setShowModal(false)} title={t("buttons.edit")}>
        {exerciseData ? (
          <>
            <div style={{ marginBottom: "1em", textAlign: "center" }}>
              <h2>{exerciseData.dictExerciseName}</h2>
            </div>

            <Formik
              enableReinitialize
              initialValues={{
                ...exerciseData,
                dictQuantityTypeId: exerciseData.dictQuantityTypeId?.toString() || "",
                dictUnitId: exerciseData.dictUnitId?.toString() || ""
              }}
              onSubmit={handleSubmit}>
              <Form>
                <div style={{ display: "grid", gap: "1em", gridTemplateColumns: "1fr 2fr" }}>
                  <Field name="quantity" type="number" />
                  <Field as="select" name="dictQuantityTypeId">
                    <option value="" disabled>{exerciseData.dictQuantityTypeName}</option>
                    {dictQuantityTypes.map((q) => (
                      <option key={q.id} value={q.id}>{q.name}</option>
                    ))}
                  </Field>

                  <Field name="volume" type="number" />
                  <Field as="select" name="dictUnitId">
                    <option value="" disabled>{exerciseData.dictUnitName}</option>
                    {dictUnits.map((u) => (
                      <option key={u.id} value={u.id}>{u.name}</option>
                    ))}
                  </Field>

                  <div style={{ gridColumn: "1 / -1" }}>
                     <Field name="notes" type="text" placeholder={t("table.notes")} className="field" />
                  </div>

                  <div style={{ gridColumn: "1 / -1", display: "flex", justifyContent: "flex-end" }}>
                    <button type="submit" className="field">{t("buttons.save")}</button>
                  </div>
                </div>
              </Form>
            </Formik>
          </>
        ) : (
          <p><span className="loader" /></p>
        )}
      </Modal>
    </>
  );
};

export default withTranslation("global")(OptionsCopyAndEdit);
